import { Img } from '@chakra-ui/image'
import { Box, Grid, GridItem, Text, VStack } from '@chakra-ui/layout'
import React from 'react'
import location from '../../assets/icon/location.png'
import ambulanceicon from '../../assets/icon/ambulanceicon.png'
import timer from '../../assets/icon/timericon.png'
import emergency from '../../assets/icon/emergency.png'
import pricing from '../../assets/icon/pricingicon.png'
import audit from '../../assets/icon/auditicon.png'

const HelpAdvantage = () => {
    return (
        <Box
            bg="#FF1111"
            color="white"
            py={16}
            px={{ base: '8', sm: '8', md: '12' }}
            mt="8rem"
        >
            <Box as="main" maxW="90vw" mx="auto" transition="0.5s ease-out">
                <Box mx={8} my={3}>
                    <Text
                        className='main-section'
                        textAlign="center"
                        color="white"
                        textTransform="uppercase"
                        fontWeight={700}
                        fontSize={'20px'}
                        letterSpacing="3px"
                    >
                        WHY CHOOSE US
                    </Text>
                    <Grid className='main-section'
                        textAlign="center"
                        mt={8}
                        px={{ base: '10px', sm: '30px', md: '10px', lg: '10px', xl: '10px' }}
                        templateColumns={{ base: 'repeat(1, 1fr)', sm: 'repeat(1, 1fr)', md: 'repeat(1, 1fr)', lg: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)' }}
                        gridRowGap={10}
                        gap={{ base: 2, sm: 2, md: 20 }}>
                        <GridItem mb={3}>
                            <VStack
                                px={{ base: '1rem', sm: '1rem', md: "2rem" }}
                                position={'relative'}>
                                <Img
                                    loading='lazy'
                                    src={location}
                                    alt={"pin"} height={12} mt="auto" mb="auto" />
                                <Text fontSize="lg"
                                    fontWeight={700}
                                    mt="6!important">
                                    Predictively parked near you
                                </Text>
                                <Text fontSize="sm"
                                    fontWeight={400}
                                    mt="7px">Our in-house technology and data science helps serving you with greater efficiency.
                                </Text>
                            </VStack>
                        </GridItem>
                        <GridItem mb={3}>
                            <VStack
                                px={{ base: '1rem', sm: '1rem', md: "2rem" }}
                            >
                                <Img
                                    loading='lazy'
                                    src={ambulanceicon}
                                    alt={"pin"} height={12} mt="auto" mb="auto" />
                                <Text fontSize="lg"
                                    fontWeight={700}
                                    mt="6!important">
                                    Certified Medical Staff
                                </Text>
                                <Text fontSize="sm"
                                    fontWeight={400}
                                    mt="7px">
                                    Ambulance Service with trained and certified medical staff and paramedics.
                                </Text>
                            </VStack>
                        </GridItem>
                        <GridItem mb={3}>
                            <VStack
                                px={{ base: '1rem', sm: '1rem', md: "2rem" }}
                            >
                                <Img
                                    loading='lazy'
                                    src={timer} alt={"pin"} height={12} mt="auto" mb="auto" />
                                <Text fontSize="lg"
                                    fontWeight={700}
                                    mt="6!important">Quickest Doctor Checkup & Advice</Text>
                                <Text fontSize="sm"
                                    fontWeight={400}
                                    mt="7px">
                                    With more ambulances added on the road and a smooth book-on-call experience.
                                </Text>
                            </VStack>
                        </GridItem>
                        <GridItem>
                            <VStack
                                px={{ base: '1rem', sm: '1rem', md: "2rem" }}
                            >
                                <Img loading='lazy'
                                    src={emergency} alt={"pin"} height={12} mt="auto" mb="auto" />
                                <Text fontSize="lg"
                                    fontWeight={700}
                                    mt="6!important">
                                    Talking to the right Hospital
                                </Text>
                                <Text fontSize="sm"
                                    fontWeight={400}
                                    mt="7px">We suggest the most relevant hospitals for your case
                                    They are pre-informed of your arrival.</Text>
                            </VStack>
                        </GridItem>
                        <GridItem>
                            <VStack
                                px={{ base: '1rem', sm: '1rem', md: "2rem" }}
                            >
                               <Img  loading='lazy'
                                    src={pricing} alt={"pin"} height={12} mt="auto" mb="auto" />
                                <Text fontSize="lg"
                                    fontWeight={700}
                                    mt="6!important">
                                    Subsidised
                                    Pricing</Text>
                                <Text fontSize="sm"
                                    fontWeight={400}
                                    mt="7px">
                                    Lowest rates of ambulance and guaranteed discounts of 15% at top govt. and pvt. hospitals.
                                </Text>
                            </VStack>
                        </GridItem>
                        <GridItem>
                            <VStack
                                px={{ base: '1rem', sm: '1rem', md: "2rem" }}
                            >
                                <Img loading='lazy'
                                    src={audit} alt={"pin"} height={12} mt="auto" mb="auto" />
                                <Text fontSize="lg"
                                    fontWeight={700}
                                    mt="6!important">
                                    Regular audits of vehicles and staff
                                </Text>
                                <Text fontSize="sm"
                                    fontWeight={400}
                                    mt="7px">
                                    All our vehicles are regularly audited and upgraded with equipments.
                                    Staff are trained and undergo surprise drills.
                                </Text>
                            </VStack>
                        </GridItem>
                    </Grid>
                </Box>
            </Box>
        </Box >
    )
}

export default HelpAdvantage